<form class="d-flex position-relative"
      [ngStyle]="{'direction':this.apiService.currentDirection ==='rtl'? 'rtl': 'ltr'}">

  <input class="form-control" placeholder="" [(ngModel)]="searchText" (keyup)="search()"
         [ngModelOptions]="{standalone: true}" #searchInput [placeholder]="'WhatServiceDoYouNeed'|translate"
         [ngClass]="this.apiService.currentDirection ==='rtl'? 'input-rtl': 'input-ltr'"/>
  <div class="form-control"
       style="transition: 1s;max-height: 230px;height: min-content; overflow-y: auto; display: none; position: absolute;top:54px; text-align: justify;padding: 0;z-index: 5"
       #searchBox id="searchBox">
    <ul id="resultResult">

    </ul>

  </div>
  <!--          <datalist id="searchResult">-->
  <!--            <option *ngFor="let item of searchResult" [value]="item.categoryId">{{item.name}}</option>-->

  <!--          </datalist>-->
  <button class="btn btn-primary custom-btn" (click)="navigateToFirstItem()"
          [ngClass]="this.apiService.currentDirection ==='rtl'? 'searchBtn-rtl': 'searchBtn-ltr'"
          type="submit">{{'Search'|translate}}
  </button>

</form>
